import React, { FC } from 'react';

const TemplateDetailsSkeleton: FC = () => (
    <div className="h-[170px] w-full rounded-[24px] border border-sf-gray-100 overflow-hidden flex">
        <div className="grow p-6 flex flex-col justify-center gap-4">
            <div className="flex flex-col items-start gap-1">
                <div className="h-[18px] rounded-sm w-[20%] bg-sf-gray-200" />
                <div className="h-3 rounded-sm w-[30%] bg-sf-gray-200" />
            </div>
            <div className="flex flex-wrap gap-2">
                <div className="h-6 w-[10%] rounded-[4px] bg-sf-gray-200" />
                <div className="h-6 w-[20%] rounded-[4px] bg-sf-gray-200" />
                <div className="h-6 w-[8%] rounded-[4px] bg-sf-gray-200" />
                <div className="h-6 w-[25%] rounded-[4px] bg-sf-gray-200" />
            </div>
        </div>
        <div className="min-w-[232px] max-w-[232px] bg-sf-gray-200" />
    </div>
);

const FieldSkeleton: FC = () => (
    <div className="h-10 flex gap-10">
        <div className="w-50 h-full rounded-[8px] bg-sf-gray-200" />
        <div className="w-80 h-full rounded-[8px] bg-sf-gray-200" />
    </div>
);

const FormSkeleton: FC = () => (
    <div className="w-[560px] flex flex-col gap-4">
        <FieldSkeleton />
        <FieldSkeleton />
        <FieldSkeleton />
        <FieldSkeleton />
    </div>
);

const FooterSkeleton: FC = () => (
    <div className="h-[56px] border-t border-sf-gray-100 px-6 gap-4 flex justify-end items-center">
        <div className="h-10 w-[66px] rounded-[12px] bg-sf-gray-200" />
        <div className="h-10 w-[104px] rounded-[12px] bg-sf-gray-200" />
    </div>
);

const CreateFromTemplateLoader: FC = () => {
    return (
        <div className="animate-pulse h-full w-full flex flex-col">
            <div className="pt-10 ps-10 pe-10 w-full flex-1 flex flex-col gap-8">
                <TemplateDetailsSkeleton />
                <FormSkeleton />
            </div>
            <FooterSkeleton />
        </div>
    );
};

export default CreateFromTemplateLoader;
